import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

export const qualifiedIncomesColumns = [
  {
    id: 'incomeType',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    label: 'Income Type',
    sort: true,
  },
  {
    id: 'hours',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    label: 'Hours',
    sort: true,
  },
  {
    id: 'hourRate',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    label: 'Hour Rate',
    sort: true,
  },
  {
    id: 'amount',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    label: 'Amount',
    sort: true,
  },
  {
    id: 'monthlyCalculatedAmount',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    label: 'Monthly Calculated Amount',
    sort: true,
  },
  {
    id: 'paidForDays',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    label: 'Paid For Days',
    sort: true,
  },
];

export const COLLAPSED_BOTTOM_PADDING = 24;
